import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import endPoint from "../redux/EndPoint/endpoint";
import { toast } from "react-toastify";

function Getaddress() {
  const [addresses, setAddresses] = useState([]);
  const [checkoutData, setCheckoutData] = useState(null);
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);
  const [shippingCost, setShippingCost] = useState(0);

  useEffect(() => {
    const fetchShippingCost = async () => {
      try {
        const response = await axios.get(
          "https://www.bharatcod.com/admin/getDeliveryCost",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        const cost = response.data.deliveryCost.shippingCost;
        setShippingCost(cost); // Update the state with the shipping cost
      } catch (error) {
        console.error("Error fetching shipping cost:", error);
      }
    };

    fetchShippingCost();
  }, []);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        if (!userId) {
          console.error("User ID not found");
          return;
        }

        const response = await axios.get(
          `https://www.bharatcod.com/user/get-user-address/${userId}`
        );

        setAddresses(response.data);
        if (response.data && response.data.length > 0) {
          const firstAddressId = response.data[0]._id;

          if (firstAddressId) {
            localStorage.setItem("addressId", firstAddressId);
          }
        } else {
          console.warn("⚠️ No addresses found to save addressId");
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    };

    fetchAddresses();
  }, [userId]);

  const handlePlaceOrder = async () => {
    setLoading(true);

    try {
      const storedCheckoutData = JSON.parse(
        localStorage.getItem("checkoutData")
      );
      const storedAddressId = localStorage.getItem("addressId");

      if (!storedCheckoutData) {
        console.error("❌ Checkout data missing, exiting function");
        setLoading(false);
        return;
      }

      if (!storedAddressId) {
        console.error("❌ Address ID missing, exiting function");
        setLoading(false);
        return;
      }
      const orderData = {
        orderID: storedCheckoutData.orderID,
        totalPrice: storedCheckoutData.totalPrice,
        platform: "website",
        addressId: storedAddressId,
        orderItems: storedCheckoutData.orderItems.map((item) => ({
          productId: item.productId,
          quantity: item.quantity,
        })),
      };
      const response = await axios.post(endPoint.PLACEORDER, orderData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      localStorage.removeItem("checkoutData");
      if (response.data.message === "Order placed successfully") {
        toast.success("🎉 Order placed successfully!");
        window.location.assign("/ThankYouPage");
      } else {
        console.error("❌ Error from API:", response.data.message);
        alert(response.data.message || "Order failed");
      }
    } catch (error) {
      console.error("💥 Error in placing order:", error);
      alert("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const storedCheckoutData = JSON.parse(localStorage.getItem("checkoutData"));
    if (storedCheckoutData) {
      setCheckoutData(storedCheckoutData);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-semibold text-gray-800 text-center mb-8">
          My Addresses
        </h1>

        {addresses.length === 0 ? (
          <p className="text-lg text-gray-600 text-center">
            You have no saved addresses.
          </p>
        ) : (
          <div className="space-y-6">
            {addresses.map((address) => (
              <div
                key={address._id}
                className="bg-white p-6 rounded-xl shadow-lg border border-gray-300 hover:shadow-xl transition duration-300 ease-in-out"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      {address.name}
                    </h3>
                    <p className="text-gray-500 text-sm capitalize">
                      {address.type} Address
                    </p>
                  </div>
                </div>

                <div className="mt-4 space-y-2 text-sm text-gray-600">
                  <p>
                    {address.location}, {address.city}
                  </p>
                  <p>
                    {address.state} - {address.pincode}
                  </p>
                  <p>📞 {address.phone}</p>
                  <p>📧 {address.email.replace("mailto:", "")}</p>
                  <p>🚚 Estimated delivery: {address.deliveryDays} days</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {checkoutData && (
        <div className="max-w-4xl mx-auto mt-12 p-6 bg-white rounded-xl shadow-lg border border-gray-300">
          <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
            🛒 Checkout Summary
          </h2>
          <p className="text-gray-700 mb-2">
            Order ID:{" "}
            <span className="font-semibold">{checkoutData?.orderID}</span>
          </p>

          {checkoutData.orderItems && checkoutData.orderItems.length > 0 && (
            <div className="mt-4 space-y-4">
              {checkoutData.orderItems.map((item, index) => (
                <div key={index} className="border p-4 rounded-lg">
                  <p className="text-lg font-semibold text-gray-800">
                    Title:
                    {item.title}
                  </p>

                  <p className=" text-black flex flex-row item-center gap-2">
                    <h4 className="text-left font-bold">Size :- </h4>
                    {item.size}
                  </p>

                  <p className=" text-gray-500 ">
                    <h4 className="text-left font-bold">Description:</h4>
                    {item.description}
                  </p>

                  <p className="text-gray-600">Quantity: {item.quantity}</p>
                  <p className="text-gray-600">
                    Price: ₹{item.selectedVariation?.price || item.totalPrice}
                  </p>
                </div>
              ))}
              <p className="text-gray-700 mb-2">
                Shipping Cost :{" "}
                <span className="font-semibold">₹{shippingCost}</span>
              </p>{" "}
              <p className="text-gray-700 mb-2">
                Total Price:{" "}
                <span className="font-semibold">
                  ₹{checkoutData?.totalPrice + shippingCost}
                </span>
              </p>
            </div>
          )}
        </div>
      )}
      <div className="relative  mb-20">
        <button
          onClick={handlePlaceOrder}
          className="w-[40%] py-3 bg-orange-500 mt-10 text-white font-semibold rounded-lg hover:bg-orange-600 transition duration-300 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          disabled={loading} // Disable the button while loading
        >
          {loading ? "Processing..." : "Place Order"}{" "}
        </button>
      </div>
    </div>
  );
}

export default Getaddress;
